<template>
  <v-dialog :persistent="persistent" v-model="dialog" max-width="600px">
    <v-card>
      <v-card-title class="mx-3">
        {{ $t("Distribution.Fields.logistic_info") }}
        <v-spacer></v-spacer>
        <v-tooltip left>
          <template v-slot:activator="{ on, attrs }">
            <v-icon v-bind="attrs" v-on="on" @click="dialog = false">
              fa-times
            </v-icon>
          </template>
          {{ $t("$vuetify.close") }}
        </v-tooltip>
      </v-card-title>
      <v-divider />
      <v-card-text>
        <ValidationObserver ref="observer">
          <v-container>
            <v-row align="center" dense>
              <v-col cols="2" class="text-right">
                {{$t("Distribution.Fields.logistics_company") + $t("Global.colon")}}
              </v-col>
              <v-col cols="4">
                <ValidationProvider
                  v-slot="{ errors }"
                  :name="$t('Distribution.Fields.logistics_company')"
                  rules="required"
                >
                  <v-combobox
                    ref="logisticsName"
                    :readonly="isReadonly"
                    v-model="logisticsName"
                    :items="logisticsItems"
                    :error-messages="errors"
                  />
                </ValidationProvider>
              </v-col>
              <v-col cols="2" class="text-right">
                {{$t("Distribution.Fields.train_number") + $t("Global.colon")}}
              </v-col>
              <v-col cols="4">
                <v-combobox
                  ref="trainNumber"
                  :readonly="isReadonly"
                  v-model="trainNumber"
                  :items="trainNumberItems"
                />
              </v-col>
            </v-row>
            <v-row align="center" dense>
              <v-col cols="2" class="text-right">
                {{ $t("Distribution.Fields.linkman") + $t("Global.colon") }}
              </v-col>
              <v-col cols="4">
                <ValidationProvider
                  v-slot="{ errors }"
                  :name="$t('Distribution.Fields.linkman')"
                  rules="required"
                >
                  <v-combobox
                    ref="logisticsLinkMan"
                    :readonly="isReadonly"
                    v-model="logisticsLinkMan"
                    :items="logisticsLinkManItems"
                    :error-messages="errors"
                  />
<!--                  <v-text-field-->
<!--                    v-model="logisticsLinkMan"-->
<!--                    single-line-->
<!--                    :error-messages="errors"-->
<!--                  />-->
                </ValidationProvider>
              </v-col>
              <v-col cols="2" class="text-right">
                {{$t("Distribution.Fields.contact_number") + $t("Global.colon")}}
              </v-col>
              <v-col cols="4">
                <ValidationProvider
                  v-slot="{ errors }"
                  :name="$t('Distribution.Fields.contact_number')"
                  rules="required"
                >
                  <v-combobox
                    ref="contactMethod"
                    :readonly="isReadonly"
                    v-model="contactMethod"
                    :items="contactMethodItems"
                    :error-messages="errors"
                  />
                </ValidationProvider>
              </v-col>
            </v-row>
            <v-row align="start" dense>
              <v-col cols="2" class="text-right">
                {{$t("Distribution.Fields.logistic_code") + $t("Global.colon")}}
              </v-col>
              <v-col cols="9">
                <!-- <ValidationProvider
                  v-slot="{ errors }"
                  :name="$t('Distribution.Fields.logistic_code')"
                  rules="required"
                > 去除物流单号必填 -->
                <v-textarea
                  outlined
                  :readonly="isReadonly"
                  v-model="logisticsCode"
                  :placeholder="$t('Distribution.logisticCodePlaceholder')"
                ></v-textarea>
                <!-- </ValidationProvider> -->
              </v-col>
            </v-row>
            <v-row align="start" dense>
              <v-col cols="2" class="text-right">
                {{$t("Distribution.Fields.logistics_img") + $t("Global.colon")}}
              </v-col>
              <v-col cols="3" v-for="(img, i) in album" :key="i">
                <v-img v-if="img" :src="img" @click.stop="$showFullscreenImages([img])">
                  <v-tooltip v-if="!isReadonly && img" right>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                        v-bind="attrs"
                        v-on="on"
                        color="secondary"
                        class="pa-2 float-right"
                        @click.stop="removeFromImages(i)"
                      >fa-times</v-icon>
                    </template>
                    <span> {{ $t("Material.delImg") }}</span>
                  </v-tooltip>
                </v-img>
              </v-col>
            </v-row>
            <v-row align="start" dense>
              <v-col cols="2" class="text-right">
              </v-col>
              <v-col cols="9">
                <!-- 上传物流图片 -->
                <v-file-input
                  v-if="!isReadonly"
                  ref="img_file"
                  show-size
                  counter
                  small-chips
                  multiple
                  suffix
                  prepend-icon="fa-camera"
                  accept="image/png, image/jpeg"
                  persistent-hint
                  :placeholder="$t('Material.imgsPlaceholder')"
                  :hint="$t('Material.imgsHint')"
                  :rules="imgRules"
                  v-model="img_file"
                >
                </v-file-input>
              </v-col>
            </v-row>
          </v-container>
        </ValidationObserver>
      </v-card-text>
      <v-card-actions v-if="!isReadonly">
        <v-spacer />
        <v-btn color="secondary" outlined @click="dialog = false">
          {{ $t("$vuetify.close") }}
        </v-btn>
        <v-btn
          color="accent"
          depressed
          @click="submit()"
        >
          {{ $t("$vuetify.save") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import i18n from "@/i18n";
import { mapState } from "vuex";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import Requisitions from "@/api/requisitions"
import Logistics from "@/api/logistics";
import Files from "@/api/files";


export default {
  name: "EditLogisticAlert",

  props: {
    value: Boolean,
    persistent: Boolean,
    requisitionId: [String,Number],
  },

  components: {
    ValidationObserver,
    ValidationProvider,
  },

  computed: {
    isReadonly() {
      return (this.requisition && this.requisition.status > 2)
    },
    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["settings"]),
  },

  data: () => ({
    dialog: false,
    requisition: {},
    logisticsName: "",
    logisticsCode: "",
    logisticsLinkMan: "",
    contactMethod: "",
    trainNumber: "",
    logisticsItems: [],
    logistics: [],
    trainNumberItems: [],
    contactMethodItems: [],
    logisticsLinkManItems: [],
    select: [],
    imgRules: [(value) => !value || value.filter((v) => v.size >= 10000000).length == 0 || i18n.t("Material.imgsHint")],
    img_file: null,
    album: [],
  }),

  methods: {
    submit() {
      this.$store.dispatch("fullscreenLoading");
      this.$refs.observer.validate().then(
        async function (result) {
          if (result) {
            //整理物流单号
            let logistic_codes = this.logisticsCode.replace("\n", ";");
            let logistics_img = [];
            if (this.img_file && this.img_file.length > 0) {
              let response = await Files.imagesUpload(this.img_file, false, 'images');
              if (response.data.status.isOK()) {
                logistics_img = (response.data.data && response.data.data.length) ? response.data.data.map((img) => img.img_name) : []
              } else {
                this.$snackbar.error(i18n.t("Material.imgUploadError"));
                this.$store.dispatch("fullscreenLoadingStop");
                return ;
              }
            }

            if (logistics_img.length == 0 && this.requisition.logistics_img_url && this.requisition.logistics_img_url.length > 0) {
              logistics_img = this.album.map((img) => img.substring(img.lastIndexOf('/') + 1))
            }
            Requisitions.editLogistics(this.requisition.id, {
              logistics_name: this.logisticsName,
              logistics_code: logistic_codes,
              logistics_link_man: this.logisticsLinkMan,
              contact_method: this.contactMethod,
              train_number: this.trainNumber,
              logistics_img: logistics_img,
            }).then(
              function (response) {
                if (response.data.status.isOK()) {
                  this.dialog = false;
                  this.logisticsName = "";
                  this.logisticsCode = "";
                  this.logisticsLinkMan = "";
                  this.contactMethod = "";
                  this.trainNumber = "";
                  this.album = [];
                  this.img_file = null;
                  this.$emit("editLogistic", null);
                  this.$refs.observer.reset();
                  this.$store.dispatch("fullscreenLoadingStop");
                } else {
                  this.$store.dispatch("fullscreenLoadingStop");
                }
              }.bind(this)
            ).catch(
              function () {
                this.$store.dispatch("fullscreenLoadingStop");
              }.bind(this)
            );
            this.$store.dispatch("fullscreenLoadingStop");
          } else {
            this.$store.dispatch("fullscreenLoadingStop");
          }
        }.bind(this)
      );
    },
    removeFromImages(i) {
      this.album.splice(i, 1);
      if (this.img_file) {
        this.img_file.splice(i, 1);
      }
    },
  },

  watch: {
    value: {
      immediate: true,
      handler() {
        this.dialog = this.value;
      },
    },
    dialog: {
      handler() {
        this.$emit("input", this.dialog);
        this.logisticsName = "";
        this.logisticsCode = "";
        this.logisticsLinkMan = "";
        this.contactMethod = "";
        this.trainNumber = "";
        if (!this.dialog) {
          this.$emit("close");
          this.img_file = null;
          this.album = [];
          this.$refs.observer.reset();
        } else {
          if (this.requisitionId) {
            Requisitions.fetchOne(this.requisitionId).then(
              function (response) {
                if (response.data.status.isOK()) {
                  this.requisition = response.data.requisition
                  if (this.requisition) {
                    if (this.requisition.logistics_img_url) {
                      this.requisition.logistics_img_url.forEach((img) => {
                        this.album.push(img)
                      })
                    }
                    if (this.requisition.logistics_json) {
                      this.logisticsName = this.requisition.logistics_json.logistics_name ? this.requisition.logistics_json.logistics_name : "";
                      this.logisticsCode = this.requisition.logistics_json.logistics_code ? this.requisition.logistics_json.logistics_code : "";
                      this.logisticsLinkMan = this.requisition.logistics_json.logistics_link_man ? this.requisition.logistics_json.logistics_link_man : "";
                      this.contactMethod = this.requisition.logistics_json.contact_method ? this.requisition.logistics_json.contact_method : "";
                      this.trainNumber = this.requisition.logistics_json.train_number ? this.requisition.logistics_json.train_number : "";
                    }
                    Logistics.fetchAll({type: 3, merge_type: 1}).then(
                      function (response) {
                        if (response.data.status.isOK()) {
                          this.logistics = response.data.logistics
                          let comboboxItem = []
                          response.data.logistics.map(
                            function (item) {
                              comboboxItem.push(item.logistics_name)
                            }.bind(this)
                          )
                          this.logisticsItems = comboboxItem
                        }
                      }.bind(this)
                    )
                  }
                }
              }.bind(this)
            )
          }
        }
      },
    },
    logisticsCode: {
      handler() {
        this.logisticsCode = this.logisticsCode.replace(";", "\n");
      },
    },
    logisticsName: {
      handler() {
        if (this.logisticsName && this.logistics.length) {
          // 待加入非包含判断 todo
          if (this.logistics.find((item) => item.logistics_name == this.logisticsName)) {
            let data = this.logistics.find((item) => item.logistics_name == this.logisticsName)
            this.trainNumberItems = data.train_number;
            this.contactMethodItems = data.contact_method;
            this.logisticsLinkManItems = data.linkman;
            if (this.requisition.logistics_json &&  this.logisticsName == this.requisition.logistics_json.logistics_name) {
              this.logisticsCode = this.requisition.logistics_json.logistics_code ? this.requisition.logistics_json.logistics_code : "";
              this.logisticsLinkMan = this.requisition.logistics_json.logistics_link_man ? this.requisition.logistics_json.logistics_link_man : "";
              this.contactMethod = this.requisition.logistics_json.contact_method ? this.requisition.logistics_json.contact_method : "";
              this.trainNumber = this.requisition.logistics_json.train_number ? this.requisition.logistics_json.train_number : "";
            }else {
              this.logisticsLinkMan = data.linkman ? data.linkman[0] : "";
              this.contactMethod = data.contact_method ? data.contact_method[0] : "";
              this.trainNumber = data.train_number ? data.train_number[0] : "";
            }
          } else {
            this.logisticsLinkMan = "";
            this.contactMethod = "";
            this.trainNumber = "";

            this.trainNumberItems = [];
            this.contactMethodItems = [];
            this.logisticsLinkManItems = [];
          }
        }
      }
    },
    img_file: {
      deep: true,
      handler() {
        this.album = [];
        if (this.img_file) {
          if (this.img_file.length > 3) {
            this.$snackbar.error(i18n.t("Material.hint"));
            this.img_file = [];
          }else {
            this.img_file.forEach((img, i) => {
              var reader = new FileReader();
              reader.readAsDataURL(img);
              let that = this;
              reader.onload = function () {
                that.album.splice(i, 0, this.result);
              };
            });
          }
        }
      },
    },
  },
};
</script>
